require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-iiscal-en-los-medios.json") })
        }
      }, "path---es-mx-update-iiscal-en-los-medios");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-iiscal-en-los-medios!./.cache/json/es-mx-update-iiscal-en-los-medios.json
// module id = 931
// module chunks = 231608221292675